import { render } from "./AdminProjectList.vue?vue&type=template&id=d6888eae&scoped=true"
import script from "./AdminProjectList.vue?vue&type=script&lang=js"
export * from "./AdminProjectList.vue?vue&type=script&lang=js"

import "./AdminProjectList.vue?vue&type=style&index=0&id=d6888eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6888eae"]])

export default __exports__